import * as React from 'react'
import { SVGProps } from 'react'

const XRPUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M31.506 19.863C29.3699 28.4313 20.6915 33.6459 12.1222 31.5092C3.55645 29.3731 -1.65806 20.6942 0.478998 12.1266C2.61418 3.55732 11.2925 -1.65758 19.8592 0.478536C28.4279 2.61466 33.6421 11.2945 31.5058 19.8632L31.5059 19.863H31.506Z'
      fill='white'
    />
    <path
      d='M21.6464 9.25522H23.9696L19.135 14.0421C17.3842 15.7747 14.5456 15.7747 12.7935 14.0421L7.95703 9.25522H10.282L13.9551 12.8915C15.0686 13.989 16.857 13.989 17.9706 12.8915L21.6464 9.25522Z'
      fill='#23292F'
    />
    <path
      d='M10.2514 22.5661H7.92676L12.7927 17.7497C14.5435 16.0171 17.3821 16.0171 19.1342 17.7497L24.0002 22.5661H21.6771L17.9726 18.9003C16.8591 17.8028 15.0707 17.8028 13.9571 18.9003L10.2514 22.5661Z'
      fill='#23292F'
    />
  </svg>
)

export default XRPUSD
